import React from 'react';
import classnames from 'classnames';
import s from './ToggleButton.scss';
var ToggleButton = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.view, view = _b === void 0 ? 'ui06-b' : _b;
    var status = value ? 'on' : 'off';
    return (React.createElement("div", { className: classnames(s['root'], s[view], s[status]), onClick: function () { return onChange(!value); } },
        React.createElement("span", { className: s['dot'] }),
        React.createElement("span", { className: s['status-text'] }, status)));
};
export default ToggleButton;
//# sourceMappingURL=ToggleButton.js.map